import { Stedsnavn } from '@/server/responses';
import { GeolocationState, SearchDropdownState } from '@/state';
import {
    ActionType,
    GetState,
    RemoveVSRLookupAction,
    SetGeolocationAction,
    SetStedsnavnMarkerAction,
} from './actiontypes';
import { Kartutsnitt } from '@/domain/kart/Kartutsnitt';
import { LegacyVegreferanse } from '@/domain/LegacyVegreferanse';
import { zoomToExtent } from './mapActions';
import { stateSearchPanelOpen, stateVegsystemreferanseSok } from '@/selectors/selectors';
import {
    lookupVSR,
    lookupVSRForLegacyVegreferanse,
    lookupVSRForVeglenkesekvens,
} from '@/middleware/fetchMisc';
import { setDropdownState, setSearchPanelOpen } from './searchActions';
import { Dispatch } from '@/state/store';

export type setGeolocationStateT = (
    geolocationState: GeolocationState
) => (dispatch: Dispatch) => void;
export const setGeolocationState: setGeolocationStateT =
    (geolocationState: GeolocationState) => (dispatch: Dispatch) => {
        const setGeoLocationAction: SetGeolocationAction = {
            type: ActionType.OVERLAY_GEOLOCATION_SET,
            geolocationState,
        };
        dispatch(setGeoLocationAction);
    };

export type getVSRForCoordinateT = (
    coordinate: [number, number]
) => (dispatch: Dispatch, getState: GetState) => void;
export const getVSRForCoordinate: getVSRForCoordinateT =
    (coordinate: [number, number]) => (dispatch: Dispatch, getState: GetState) => {
        if (stateVegsystemreferanseSok(getState())) {
            dispatch(clearVSRLookup());
        }
        dispatch(lookupVSR(coordinate));
    };

export type getVSRForCoordinateAndZoomT = (
    coordinate: [number, number]
) => (dispatch: Dispatch, getState: GetState) => void;
export const getVSRForCoordinateAndZoom: getVSRForCoordinateAndZoomT =
    (coordinate: [number, number]) => (dispatch: Dispatch, getState: GetState) => {
        if (stateVegsystemreferanseSok(getState())) {
            dispatch(clearVSRLookup());
        }
        dispatch(lookupVSR(coordinate, true));
    };

export type getVSRForVeglenkesekvensT = (
    veglenkesekvens: string
) => (dispatch: Dispatch, getState: GetState) => void;
export const getVSRForVeglenkesekvens: getVSRForVeglenkesekvensT =
    (veglenkesekvens: string) => (dispatch: Dispatch, getState: GetState) => {
        if (stateVegsystemreferanseSok(getState())) {
            dispatch(clearVSRLookup());
        }
        dispatch(lookupVSRForVeglenkesekvens(veglenkesekvens));
    };

export type getVSRForVeglenkesekvensAndZoomT = (
    veglenkesekvens: string
) => (dispatch: Dispatch, getState: GetState) => void;
export const getVSRForVeglenkesekvensAndZoom: getVSRForVeglenkesekvensAndZoomT =
    (veglenkesekvens: string) => (dispatch: Dispatch, getState: GetState) => {
        if (stateVegsystemreferanseSok(getState())) {
            dispatch(clearVSRLookup());
        }
        dispatch(lookupVSRForVeglenkesekvens(veglenkesekvens, true));
    };

export type getVSRForLegacyVegreferanseT = (
    vegreferanse: LegacyVegreferanse
) => (dispatch: Dispatch, getState: GetState) => Promise<void>;
export const getVSRForLegacyVegreferanse: getVSRForLegacyVegreferanseT =
    (vegreferanse: LegacyVegreferanse) => (dispatch: Dispatch, getState: GetState) => {
        if (stateVegsystemreferanseSok(getState())) {
            dispatch(clearVSRLookup());
        }
        return dispatch(lookupVSRForLegacyVegreferanse(vegreferanse));
    };

export type clearVSRLookupT = () => (dispatch: Dispatch) => void;
export const clearVSRLookup: clearVSRLookupT = () => (dispatch: Dispatch) => {
    const removeVSRLookupAction: RemoveVSRLookupAction = {
        type: ActionType.OVERLAY_VEGSYSTEMREFERANSE_REMOVED,
    };
    dispatch(removeVSRLookupAction);
};

export type setPlacenameMarkerT = (
    stedsnavn: Stedsnavn | null
) => (dispatch: Dispatch, getState: GetState) => void;
export const setPlacenameMarker: setPlacenameMarkerT =
    (stedsnavn: Stedsnavn | null) => (dispatch: Dispatch, getState: GetState) => {
        const setStedsnavnMarkerAction: SetStedsnavnMarkerAction = {
            type: ActionType.OVERLAY_STEDSNAVN_ADDED,
            stedsnavn,
        };
        dispatch(setStedsnavnMarkerAction);

        // Clear marker if placenameMarker is null. Do not zoom and update state in this case.
        if (stedsnavn) {
            const x = parseInt(stedsnavn.xCoord);
            const y = parseInt(stedsnavn.yCoord);

            const kartutsnitt = Kartutsnitt.fromPoint(x, y);

            dispatch(zoomToExtent(kartutsnitt));
            dispatch(setDropdownState(new SearchDropdownState()));
            if (stateSearchPanelOpen(getState())) dispatch(setSearchPanelOpen(false));
        }
    };
